import { useContext } from 'react';
import PlanejamentoInicialContext from 'src/contexts/PlanejamentoInicialContext';

const usePlanejamentoInicial = () => useContext(PlanejamentoInicialContext);

export default usePlanejamentoInicial;
